<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1 id="agendar">Formulário de Agendamento <span v-if="userType === 'agencia_turismo'">para Agências de Turismo</span></h1>
        <p>Se for desistir desse roteiro, clique em Desistir ou feche essa janela. Jamais feche esse formulário se pretende continuar com seu agendamento, pois isso cancelará todo o processo!</p>
        <p>Reservando para: {{ email }} | Ticket provisório: {{ ticket }}</p>
        <p v-if="responseroteiro">Título: {{ responseroteiro.titulo }}</p>
      </div>
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-md-6 text-end">
            <p v-if="responseroteiro">
              <b>Dia da Semana:</b>
              {{ responseroteiro.diasem }}
            </p>
            <p v-if="responseroteiro">
              <b>Data:</b>
              {{ responseroteiro.datedisplay }}
            </p>
            <p v-if="responseroteiro">
              <b>Horário:</b>
              {{ formatHorario(responseroteiro.codigo) }}
            </p>
          </div>
          <div class="col-12 col-md-6 text-start">
            <p v-if="responseroteiro">
              <b>Descrição:</b>
              {{ responseroteiro.descricao }}
            </p>
            <p v-if="responseroteiro">
              <b>Vagas:</b>
              {{ responseroteiro.vagas }}
            </p>
            <p v-if="responseroteiro">
              <b>Duração da visita:</b>
              {{ responseroteiro.duracao }}
            </p>
          </div>
        </div>
      </div>
      <div v-if="ticket" class="col-12 d-flex gap-5 justify-content-center my-4">
        <button @click="seguir = true" class="btn btn-success">Continuar</button>
        <button @click="desistir()" class="btn btn-danger">Desistir</button>
      </div>
      <div v-else class="col-12 d-flex gap-5 justify-content-center my-4">
        <p><mark>Este item já está em reserva.</mark></p>
      </div>
      <div class="col-12" v-if="seguir">
        <div v-if="userType === 'diretor_professor_responsavel' || userType === 'eurbw34r98gh'">
          <form @submit.prevent="submitForm" class="d-flex flex-column gap-3 my-5">
            <!-- Restante do formulário -->
            <div>
              <div class="row">
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="instituicao"><b>Nome da instituição/escola:</b></label>
                  <input type="text" id="instituicao" v-model="formData.instituicao" placeholder="Digite aqui o nome da instituição" required />
                </div>
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="nomecontato"><b>Nome do responsável pela instituição/escola:</b></label>
                  <input type="text" id="nomecontato" name="nomecontato" v-model="formData.nomecontato" placeholder="Nome do responsável" />
                </div>
               
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-12 col-md-4 d-flex flex-column gap-3">
                  <label for="cargo"><b>Cargo na instituição/escola:</b></label>
                  <input type="text" id="cargo" name="cargo" v-model="formData.cargo" placeholder="Cargo do responsável" />
                </div>
                <div class="col-12 col-md-4 d-flex flex-column gap-3">
                  <label for="obs"><b>Informações de contato na instituição/escola:</b></label>
                  <input type="text" id="obs" v-model="formData.obs" required />
                </div>
                  <div class="col-12 col-md-4 d-flex flex-column gap-3">
                  <label for="obswp"><b>Whatsapp do responsável - Obrigatório:</b></label>
                  <input type="text" id="obswp" v-model="formData.obswp" required />
                </div>
               
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="cnpj"><b>CNPJ da instituição/escola:</b></label>
                  <input type="text" @blur="checaCNPJ" id="cnpj" v-model="formData.cnpj" placeholder="Digite aqui o CNPJ" required />
                  <p class="irregular" v-if="cnpjInvalido">Cnpj Inválido. Não é permitido que o CNPJ da agência e da Escola/Instituição sejam iguais ou um CNPJ inválido. Por favor, verifique e tente novamente.</p>
                </div>
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="tipo"><b>Tipo de instituição/escola:</b></label>
                  <select name="tipo" id="tipo" v-model="formData.tipo" required>
                    <option value="Escola Particular">Escola Particular</option>
                    <option value="Escola Municipal">Escola Municipal</option>
                    <option value="Escola Estadual">Escola Estadual</option>
                    <option value="Ong (Organização não governamental)">Ong (Organização não governamental)</option>
                    <option value="Empresa">Empresa</option>
                    <option value="Universidade Pública">Universidade Pública</option>
                    <option value="Universidade Privada">Universidade Privada</option>
                    <option value="Outros tipos (Lar de idosos, Cursinho)">Outros tipos (Lar de idosos, Cursinho)</option>
                  </select>
                </div>
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="endereco"><b>Endereço da Instituição/escola:</b></label>
                  <input type="text" id="endereco" v-model="formData.endereco" placeholder="Digite aqui o endereço" required />
                </div>
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="quantidade"><b>Quantidade máxima para este roteiro é {{ responseroteiro.vagas }}</b></label>
                  <input type="number" id="quantidade" v-model="formData.quantidade" :max="responseroteiro.vagas" placeholder="Digite aqui a quantidade" required />
                  <span>A cada grupo de 20, 1 pessoa é responsável. Exemplo: em um grupo de 20 pessoas, 19 são alunos e 1 é professor(a)</span>
                </div>
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-12 d-flex flex-column gap-3">
                  <label for="serie"><b>Série/Faixa Etária</b></label>
                  <div class="d-flex gap-5 flex-row flex-wrap">
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="1AnoFund" value="1º ano fundamental" v-model="formData.series" /><label for="1AnoFund">1º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="2AnoFund" value="2º ano fundamental" v-model="formData.series" /><label for="2AnoFund">2º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="3AnoFund" value="3º ano fundamental" v-model="formData.series" /><label for="3AnoFund">3º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="4AnoFund" value="4º ano fundamental" v-model="formData.series" /><label for="4AnoFund">4º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="5AnoFund" value="5º ano fundamental" v-model="formData.series" /><label for="5AnoFund">5º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="6AnoFund" value="6º ano fundamental" v-model="formData.series" /><label for="6AnoFund">6º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="7AnoFund" value="7º ano fundamental" v-model="formData.series" /><label for="7AnoFund">7º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="8AnoFund" value="8º ano fundamental" v-model="formData.series" /><label for="8AnoFund">8º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="9AnoFund" value="9º ano fundamental" v-model="formData.series" /><label for="9AnoFund">9º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="1AnoMedio" value="1º Ano Médio" v-model="formData.series" /><label for="1AnoMedio">1º Ano Médio</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="2AnoMedio" value="2º Ano Médio" v-model="formData.series" /><label for="2AnoMedio">2º Ano Médio</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="3AnoMedio" value="3º Ano Médio" v-model="formData.series" /><label for="3AnoMedio">3º Ano Médio</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="Crianca" value="Criança" v-model="formData.series" /><label for="Crianca">Criança</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="Jovem" value="Jovem" v-model="formData.series" /><label for="Jovem">Jovem</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="Adulto" value="Adulto" v-model="formData.series" /><label for="Adulto">Adulto</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="Idosos" value="Idosos" v-model="formData.series" /><label for="Idosos">Idosos</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="Superior" value="Superior" v-model="formData.series" /><label for="Superior">Superior</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="EduInfantil" value="Educação Infantil" v-model="formData.series" /><label for="EduInfantil">Educação Infantil</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="Professor" value="Professor" v-model="formData.series" /><label for="Professor">Professor</label></div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="row my-5">
                <div class="col-12 col-md-6">
                  <DeficienciaForm @update:deficiencias="handleDeficienciasUpdate" />
                </div>
                <div class="col-12 col-md-6">
                  <div class="d-flex gap-4">
                    <input type="checkbox" name="ciente" id="ciente" v-model="isChecked" />
                    <label for="ciente">Ciente que aos finais de semana, feriados e emendas de feriados não haverá monitoria, sendo a visitação livre.</label>
                  </div>
                  <button type="submit" class="btn btn-primary" :disabled="!isChecked">Enviar</button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div v-else-if="userType === 'agencia_turismo'">
          <form @submit.prevent="submitForm" class="d-flex flex-column gap-3 my-5">
            <div class="row">
              <div class="col-12">
                <h2>Informações da Agência de Turismo</h2>
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="instituicao2"><b>Nome da agência:</b></label>
                  <input type="text" id="instituicao2" v-model="formData.instituicao2" placeholder="Digite aqui o nome da instituição" required />
                </div>
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="nomecontato2"><b>Nome do responsável pela agência:</b></label>
                  <input type="text" id="nomecontato2" name="nomecontato2" v-model="formData.nomecontato2" placeholder="Nome do responsável" />
                </div>
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="cargo2"><b>Cargo do responsável pela agência:</b></label>
                  <input type="text" id="cargo2" name="cargo2" v-model="formData.cargo2" placeholder="Cargo do responsável" />
                
                  <label for="obswp"><b>Whatsapp do responsável - Obrigatório:</b></label>
                  <input type="text" id="obswp" v-model="formData.obswp" required />
                
                </div>
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="obs2"><b>Informações de contato da agência:</b></label>
                  <input type="text" id="obs2" v-model="formData.obs2" placeholder="Telefone/Celular" required />
                  <label for="obs3"><b>E-mail da agência:</b></label>
                  <input type="email" id="obs3" v-model="formData.obs3" required />
                  <label for="cnpj2"><b>CNPJ da agência:</b></label>
                  <input type="text" @blur="checaCNPJ2" id="cnpj2" v-model="formData.cnpj2" placeholder="Digite aqui o CNPJ" required />
                  <p class="irregular" v-if="cnpjInvalido2">Cnpj Inválido. Não é permitido que o CNPJ da agência e da Escola/Instituição sejam iguais ou um CNPJ inválido. Por favor, verifique e tente novamente.</p>
                </div>
                
              </div>
            </div>
            <div class="row">
              <div class="col-12 mt-5">
                <h2>Informações da Instituição (Por exemplo: Escola)</h2>
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="instituicao"><b>Nome da instituição:</b></label>
                  <input type="text" id="instituicao" v-model="formData.instituicao" placeholder="Digite aqui o nome da instituição" required />
                </div>
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="nomecontato"><b>Nome do responsável pela instituição/escola:</b></label>
                  <input type="text" id="nomecontato" name="nomecontato" v-model="formData.nomecontato" placeholder="Nome do responsável" />
                </div>
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="cargo"><b>Cargo do responsável na instituição/escola:</b></label>
                  <input type="text" id="cargo" name="cargo" v-model="formData.cargo" placeholder="Cargo do responsável" />
                </div>
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="obs"><b>Informações de contato da instituição/escola:</b></label>
                  <input type="text" id="obs" v-model="formData.obs" required />
                </div>
             
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="cnpj"><b>CNPJ da instituição/escola:</b></label>
                  <input type="text" @blur="checaCNPJ" id="cnpj" v-model="formData.cnpj" placeholder="Digite aqui o CNPJ" required />
                  <p class="irregular" v-if="cnpjInvalido">Cnpj Inválido. Não é permitido que o CNPJ da agência e da Escola/Instituição sejam iguais ou um CNPJ inválido. Por favor, verifique e tente novamente.</p>
                </div>
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="tipo"><b>Tipo de instituição:</b></label>
                  <select name="tipo" id="tipo" v-model="formData.tipo" required>
                    <option value="Escola Particular">Escola Particular</option>
                    <option value="Escola Municipal">Escola Municipal</option>
                    <option value="Escola Estadual">Escola Estadual</option>
                    <option value="Ong (Organização não governamental)">Ong (Organização não governamental)</option>
                    <option value="Empresa">Empresa</option>
                    <option value="Universidade Pública">Universidade Pública</option>
                    <option value="Universidade Privada">Universidade Privada</option>
                    <option value="Outros tipos (Lar de idosos, Cursinho)">Outros tipos (Lar de idosos, Cursinho)</option>
                  </select>
                </div>
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="endereco"><b>Endereço da Instituição/escola:</b></label>
                  <input type="text" id="endereco" v-model="formData.endereco" placeholder="Digite aqui o endereço" required />
                </div>
                <div class="col-12 col-md-6 d-flex flex-column gap-3">
                  <label for="quantidade"><b>Quantidade máxima para este roteiro é {{ responseroteiro.vagas }}</b></label>
                  <input type="number" id="quantidade" v-model="formData.quantidade" :max="responseroteiro.vagas" placeholder="Digite aqui a quantidade" required />
                  <span>A cada grupo de 20, 1 pessoa é responsável. Exemplo: em um grupo de 20 pessoas, 19 são alunos e 1 é professor(a)</span>
                </div>
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-12 d-flex flex-column gap-3">
                  <label for="serie"><b>Série/Faixa Etária</b></label>
                  <div class="d-flex gap-5 flex-row flex-wrap">
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="1AnoFund" value="1º ano fundamental" v-model="formData.series" /><label for="1AnoFund">1º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="2AnoFund" value="2º ano fundamental" v-model="formData.series" /><label for="2AnoFund">2º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="3AnoFund" value="3º ano fundamental" v-model="formData.series" /><label for="3AnoFund">3º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="4AnoFund" value="4º ano fundamental" v-model="formData.series" /><label for="4AnoFund">4º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="5AnoFund" value="5º ano fundamental" v-model="formData.series" /><label for="5AnoFund">5º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="6AnoFund" value="6º ano fundamental" v-model="formData.series" /><label for="6AnoFund">6º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="7AnoFund" value="7º ano fundamental" v-model="formData.series" /><label for="7AnoFund">7º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="8AnoFund" value="8º ano fundamental" v-model="formData.series" /><label for="8AnoFund">8º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="9AnoFund" value="9º ano fundamental" v-model="formData.series" /><label for="9AnoFund">9º ano fundamental</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="1AnoMedio" value="1º Ano Médio" v-model="formData.series" /><label for="1AnoMedio">1º Ano Médio</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="2AnoMedio" value="2º Ano Médio" v-model="formData.series" /><label for="2AnoMedio">2º Ano Médio</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="3AnoMedio" value="3º Ano Médio" v-model="formData.series" /><label for="3AnoMedio">3º Ano Médio</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="Crianca" value="Criança" v-model="formData.series" /><label for="Crianca">Criança</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="Jovem" value="Jovem" v-model="formData.series" /><label for="Jovem">Jovem</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="Adulto" value="Adulto" v-model="formData.series" /><label for="Adulto">Adulto</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="Idosos" value="Idosos" v-model="formData.series" /><label for="Idosos">Idosos</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="Superior" value="Superior" v-model="formData.series" /><label for="Superior">Superior</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="EduInfantil" value="Educação Infantil" v-model="formData.series" /><label for="EduInfantil">Educação Infantil</label></div>
                    <div class="d-flex gap-3 justify-content-start"><input type="checkbox" id="Professor" value="Professor" v-model="formData.series" /><label for="Professor">Professor</label></div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="row">
                <div class="col-12 col-md-6">
                  <DeficienciaForm @update:deficiencias="handleDeficienciasUpdate" />
                </div>
                <div class="col-12 col-md-6">
                  <div class="d-flex gap-4">
                    <input type="checkbox" name="ciente" id="ciente" v-model="isChecked" />
                    <label for="ciente">Ciente que aos finais de semana, feriados e emendas de feriados não haverá monitoria, sendo a visitação livre.</label>
                  </div>
                  <button type="submit" class="btn btn-primary" :disabled="!isChecked">Enviar</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watchEffect, watch, onMounted, onUnmounted } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";
import { getCurrentUser } from "@/services/authService";
import DeficienciaForm from "@/components/DeficienciaForm.vue";

const restricoesforcadas = [
'2024110110300016',
'2024110115000016',
'2024110810300016',
'2024110815000016',
'2024111510300016',
'2024111515000016',
'2024112210300016',
'2024112215000016',
'2024112910300016',
'2024112915000016'
];

const seguir = ref(false);
const email = localStorage.getItem('userEmail');
const ticket = ref(localStorage.getItem('ticket'));
const codigo = localStorage.getItem('codigoemreserva');
const userType = localStorage.getItem('userType');
const deficienciasRecebidas = ref([]);
const handleDeficienciasUpdate = (deficiencias) => {
  deficienciasRecebidas.value = deficiencias;
};

const isChecked = ref(false);
const cnpjInvalido = ref(false);
const cnpjInvalido2 = ref(false);
const isAgencia = ref(false);
const router = useRouter();
const submitSuccess = ref(false);  // Variável de controle

// Função para formatar diamaster a partir de codigo
const formatDiaMaster = () => {

  const ano = codigo.substring(0, 4);
  const mes = codigo.substring(4, 6);
  const dia = codigo.substring(6, 8);
  return `${ano}-${mes}-${dia}`;
};

const formData = ref({
  cnpj: "",
  cnpj2: "",
  agencia: "",
  nomecontato: "",
  nomecontato2: "",
  cargo: "",
  cargo2: "",
  deficiencia: deficienciasRecebidas.value,
  email: getCurrentUser(),
  endereco: "",
  id: codigo,
  ticket: ticket.value,
  quantidade: "",
  series: [],
  obs: "",
  obswp: "",
  obs2: "",
  obs3: "",
  tipo: "",
  diamaster: formatDiaMaster(),
  aprovacao: "pendente",
});

watch(deficienciasRecebidas, (newVal) => {
  formData.value.deficiencia = newVal;
});

watch(
  () => formData.value.cnpj,
  (novoCNPJ) => {
    let value = novoCNPJ.replace(/\D/g, ""); // Remove caracteres não numéricos
    if (value.length > 14) {
      value = value.slice(0, 14); // Limita a 14 caracteres
    }
    value = value.replace(/^(\d{2})(\d)/, "$1.$2");
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
    value = value.replace(/(\d{4})(\d)/, "$1-$2");
    formData.value.cnpj = value; // Atualiza o valor formatado

    if (novoCNPJ === "") {
      cnpjInvalido.value = false;
    } else {
      checaCNPJ();
    }
  }
);

watch(
  () => formData.value.cnpj2,
  (novoCNPJ) => {
    let value = novoCNPJ.replace(/\D/g, ""); // Remove caracteres não numéricos
    if (value.length > 14) {
      value = value.slice(0, 14); // Limita a 14 caracteres
    }
    value = value.replace(/^(\d{2})(\d)/, "$1.$2");
    value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
    value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
    value = value.replace(/(\d{4})(\d)/, "$1-$2");
    formData.value.cnpj2 = value; // Atualiza o valor formatado

    if (novoCNPJ === "") {
      cnpjInvalido2.value = false;
    } else {
      checaCNPJ2();
    }
  }
);


watch(() => formData.value.obs, (novoTelefone) => {
  let value = novoTelefone.replace(/\D/g, ""); // Remove caracteres não numéricos
  if (value.length > 11) {
    value = value.slice(0, 11); // Limita a 11 caracteres, adequado para celulares no Brasil
  }
  value = value.replace(/^(\d{2})(\d)/, "($1) $2"); // Insere o DDD entre parênteses
  value = value.replace(/(\d{5})(\d)/, "$1-$2"); // Insere o hífen entre o quinto e sexto dígitos
  formData.value.obs = value; // Atualiza o valor formatado

  if (novoTelefone === "") {
    // Aqui você pode adicionar qualquer lógica adicional necessária para quando o campo estiver vazio
  } else {
    // Aqui você pode adicionar qualquer lógica de validação do número de telefone, se necessário
  }
});

watch(() => formData.value.obswp, (novoTelefone) => {
  let value = novoTelefone.replace(/\D/g, ""); // Remove caracteres não numéricos
  if (value.length > 11) {
    value = value.slice(0, 11); // Limita a 11 caracteres, adequado para celulares no Brasil
  }
  value = value.replace(/^(\d{2})(\d)/, "($1) $2"); // Insere o DDD entre parênteses
  value = value.replace(/(\d{5})(\d)/, "$1-$2"); // Insere o hífen entre o quinto e sexto dígitos
  formData.value.obswp = value; // Atualiza o valor formatado

  if (novoTelefone === "") {
    // Aqui você pode adicionar qualquer lógica adicional necessária para quando o campo estiver vazio
  } else {
    // Aqui você pode adicionar qualquer lógica de validação do número de telefone, se necessário
  }
});


watch(() => formData.value.obs2, (novoTelefone) => {
  let value = novoTelefone.replace(/\D/g, ""); // Remove caracteres não numéricos
  if (value.length > 11) {
    value = value.slice(0, 11); // Limita a 11 caracteres, adequado para celulares no Brasil
  }
  value = value.replace(/^(\d{2})(\d)/, "($1) $2"); // Insere o DDD entre parênteses
  value = value.replace(/(\d{5})(\d)/, "$1-$2"); // Insere o hífen entre o quinto e sexto dígitos
  formData.value.obs2 = value; // Atualiza o valor formatado

  if (novoTelefone === "") {
    // Aqui você pode adicionar qualquer lógica adicional necessária para quando o campo estiver vazio
  } else {
    // Aqui você pode adicionar qualquer lógica de validação do número de telefone, se necessário
  }
});

watchEffect(() => {
  formData.value.agencia = isAgencia.value ? 'É uma agência' : 'Não é uma agência';
});

const submitForm = () => {
  // Verificar se o código em questão está nas restrições forçadas
  if (restricoesforcadas.includes(codigo)) {
    // Verificar se o valor de `series` contém apenas 'Educação Infantil' ou '1º ano fundamental'
    const seriesPermitidas = ["Educação Infantil"];
    const seriesSelecionadas = formData.value.series;
    const seriesValidas = seriesSelecionadas.every(serie => seriesPermitidas.includes(serie));
    
    // Caso não sejam válidas, mostrar um alerta e interromper o submit
    if (!seriesValidas) {
      alert("Para este código, somente Educação Infantil ou 1º ano fundamental são permitidos.");
      return; // Impede o envio do formulário
    }
  }

  // Verificar se há CNPJ inválido
  if (cnpjInvalido.value || cnpjInvalido2.value) {
    alert("Por favor, insira um CNPJ válido.");
    return; // Impede o envio do formulário
  }

  // Verificar se os CNPJs são iguais
  if (formData.value.cnpj === formData.value.cnpj2) {
    alert("Os CNPJs não podem ser iguais.");
    return; // Impede o envio do formulário
  }

  axios
    .post(
      "https://museucatavento.org.br/sistema-agendamento/api.php",
      formData.value,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      if (response.data === 'O CNPJ em questão já reservou no limite de dias e de mês.') {
        alert(response.data);
        localStorage.removeItem('ticket');
        desistir2();
      } else {
        axios
          .get('https://museucatavento.org.br/envio/enviocomprovante.php', {
            params: {
              bid: ticket.value,
              emailusuario: email,
            },
          })
          .then(() => {
            alert("Comprovante do ticket " + ticket.value + " enviado para seu e-mail");
          })
          .catch((error) => {
            console.error('Erro ao realizar agendamento: ', error);
          });
        localStorage.removeItem('ticket');
        submitSuccess.value = true; // Marca a submissão como bem-sucedida
        alert(response.data);
        router.push("/registros");
      }
    })
    .catch((error) => {
      alert(error);
    });
};


function checaCNPJ() {
  cnpjInvalido.value = !validaCNPJ(formData.value.cnpj);
}

function checaCNPJ2() {
  cnpjInvalido2.value = !validaCNPJ(formData.value.cnpj2);
}

function validaCNPJ(pcnpj) {
  pcnpj = pcnpj.replace(/[^\d]+/g, "");

  if (pcnpj === "") return false;
  if (pcnpj.length !== 14) return false;

  // Elimina pCNPJs inválidos conhecidos
  if (/^(\d)\1+$/.test(pcnpj)) return false;

  // Valida DVs
  let tamanho = pcnpj.length - 2;
  let numeros = pcnpj.substring(0, tamanho);
  let digitos = pcnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(0)) return false;

  tamanho = tamanho + 1;
  numeros = pcnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado != digitos.charAt(1)) return false;

  return true;
}

const responseroteiro = ref(null);

const fetchRoteiroInfo = async () => {
  try {
    const response = await axios.get('https://museucatavento.org.br/sistema-agendamento/apiroteirosinfo.php', {
      params: { codigus: codigo }
    });

    if (response.data && response.data.length > 0) {
      responseroteiro.value = response.data[0];
    } else {
      console.log('Nenhum dado encontrado para o código fornecido.');
    }
  } catch (error) {
    console.error('Erro ao buscar informações do roteiro:', error);
  }
};

const desistir = async () => {
  try {
    await axios.post('https://museucatavento.org.br/sistema-agendamento/apidesistir.php', { codigus: ticket.value });
    console.log('Desistência registrada.');
    router.push('/');
  } catch (error) {
    console.error('Erro ao registrar desistência:', error);
  }
}
const desistir2 = async () => {
  try {
    await axios.post('https://museucatavento.org.br/sistema-agendamento/apidesistir.php', { codigus: ticket.value });
    console.log('Desistência registrada.');
    router.push('/avisorestricao');
  } catch (error) {
    console.error('Erro ao registrar desistência:', error);
  }
}
const formatHorario = (codigo) => {
  if (!codigo || codigo.length < 15) {
    return '';
  }
  const horario = codigo.substring(8, 12); // Extrai o trecho que representa o horário
  return `${horario.substring(0, 2)}h${horario.substring(2, 4)}`; // Formata como HHhMM
};

onMounted(() => {
  console.log("Aqui iniciamos o formulário");
  fetchRoteiroInfo();
  window.addEventListener('beforeunload', () => {
    if (!submitSuccess.value) {
      navigator.sendBeacon('https://museucatavento.org.br/sistema-agendamento/apidesistir.php', JSON.stringify({ codigus: ticket.value }));
    }
  });
});

onUnmounted(() => {
  if (!submitSuccess.value) {
    window.removeEventListener('beforeunload', () => {
      navigator.sendBeacon('https://museucatavento.org.br/sistema-agendamento/apidesistir.php', JSON.stringify({ codigus: ticket.value }));
    });
  }
});
</script>

<style scoped>
.container {
  margin-top: 2rem;
  margin-bottom: 3rem;
  background: var(--catavento-surface, #fff);
  border: 1px solid var(--catavento-border, #d9e1ea);
  border-radius: var(--catavento-radius, 8px);
  box-shadow: var(--catavento-shadow, 0 10px 28px rgba(20, 30, 45, 0.12));
  padding: clamp(1rem, 3vw, 2rem);
}
.row {
  row-gap: 1rem;
}

form {
  text-align: left;
}

form > div {
  padding-bottom: 0.25rem;
}

label {
  margin-bottom: 0.15rem;
}

span {
  color: var(--catavento-muted, #667085);
  font-size: 0.95rem;
}

.irregular {
  background-color: #c24a4a;
  color: white;
  padding: 0.65rem 0.75rem;
  border-radius: 6px;
  margin-top: 0.5rem;
}

@media (max-width: 767px) {
  .container {
    margin-top: 1rem;
    padding: 1rem;
  }

  .text-end,
  .text-start {
    text-align: left !important;
  }

  .col-12.d-flex.gap-5,
  .d-flex.gap-5.flex-row {
    gap: 0.85rem !important;
  }

  .col-12.d-flex.gap-5.justify-content-center {
    flex-direction: column;
  }

  button {
    width: 100%;
  }
}
</style>
